<div class="aba-tarefa">
  <div class="bloco-tarefa">

    <div class="col">
      <div class="bloco-tipos-tarefas">
        <a (click)="navigateTo('/tarefas')">
          <div class="item-header">
            <span>Tarefas</span>
            <h2>Por obras</h2>
          </div>
          <p>Acompanhe suas tarefas vinculadas às obras.</p>
        </a>
      </div>
    </div>

    <ng-container *ngIf="exibirTarefasEmpresa">
      <div class="linha"></div>

      <div class="col">
        <div class="bloco-tipos-tarefas">
          <a (click)="navigateTo('/empresas/tarefas')">
            <div class="item-header">
              <span>Tarefas</span>
              <h2>Por empresa</h2>
            </div>
            <p>Acompanhe suas tarefas agrupadas por empresa.</p>
          </a>
        </div>
      </div>
    </ng-container>

  </div>
</div>
